import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgSuperbottleGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M15.37 9.5c.41 0 .75-.34.75-.75S15.78 8 15.37 8H8.75c-.41 0-.75.34-.75.75v13.24c0 .41.34.75.75.75s.75-.34.75-.75v-5.87h5.87c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H9.5V9.5h5.87ZM15.37 26.76c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H8.75c-.41 0-.75.34-.75.75v13.23c0 .42.34.76.75.76s.75-.34.75-.75v-5.87h5.87c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H9.5v-5.12h5.87ZM38.3 8H26.96c-.94 0-1.7.76-1.7 1.7v28.6c0 .2.08.39.22.53l.95.95c.14.14.33.22.53.22H38.3c.2 0 .39-.08.53-.22l.95-.95a.75.75 0 0 0 .22-.53V9.7c0-.94-.76-1.7-1.7-1.7ZM26.96 9.5H38.3c.11 0 .2.09.2.2v13.55H26.76V9.7c0-.11.09-.2.2-.2Zm11.03 29H27.27l-.51-.51V24.75H38.5v13.24l-.51.51Z",
    fill: "currentColor"
  }));
}

export { SvgSuperbottleGlyphSecondary as default };
